/*
	After some async processes, we sometimes receive notifications that there are new Assets
	added to a library, and we need to inject them into the store to be displayed in grids.
*/

import { useCallback } from "react";
import { Assets } from "reducers/Assets";
import { useDispatch, useSelector } from "react-redux";
import useFTMessage from "hooks/Notification";
import { JCRM_SOCKET } from "utils/constants";

const uploadTerminalStatusNames = [
	"Success",
	"warn",
	"Failed",
];

export function useAssetSocket(){
	const dispatch = useDispatch();
	const currentLibraryId = useSelector(state => state.libraryProperties.id);

	const handleMessage = useCallback(({ detail }) => {
		let { message } = detail;

		if(message.origin === JCRM_SOCKET){
			const isVideoTask = /encode video|upload video/i.test(message.task);
			const isImposiumDuplication = /Imposium Project Duplication/i.test(message.task);

			if(!isVideoTask && !isImposiumDuplication){ return; }
			if(!/success/i.test(message.status)){ return; }

			// Imposium duplication uses different data structure
			if(isImposiumDuplication){
				dispatch(Assets.addSocketAsset(message.data?.library, message.data?.imposiumProject));
			} else {
				dispatch(Assets.addSocketAsset(message.data?.creativeLibrary, message.data?.asset));
			}
		}

		if(message.origin === "HOPI"){
			if((message.task === "Upload Assets") && uploadTerminalStatusNames.includes(message.status)){
				/*
					This is a bulk asset upload batch completion, and we need to refresh the whole Assets grid
					because we don't have more targeted data to inject, because the upload endpoints
					don't return anything after successful upload
				*/
				let { libraryId } = message.data;

				if(parseInt(libraryId) === parseInt(currentLibraryId)){
					dispatch(Assets.loadAssets(libraryId, null, { excludeSubTypes: ["QR"]}));
				}
			}
		}
	}, [currentLibraryId]);

	useFTMessage(handleMessage);
}

export function AssetSocketListener({ children }){
	useAssetSocket();

	return children;
}
